var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGiphy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GIF-img-in-conversation",
    transform: "translate(-101.000000, -627.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 127.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reply",
    transform: "translate(46.000000, 299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(35.000000, 201.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "giphy-logo-1",
    transform: "translate(4.666667, 3.333333)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#000000",
    points: "1.55386077 1.52386346 9.32583107 1.52386346 9.32583107 11.8082753 1.55319417 11.8082753"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#04FF8E",
    points: "0 1.14256429 1.55386077 1.14256429 1.55386077 12.1895745 0 12.1895745"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8E2EFF",
    points: "9.32516447 4.19029122 10.8790252 4.19029122 10.8790252 12.1895745 9.32516447 12.1895745"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00C5FF",
    points: "0 11.8082753 10.8790252 11.8082753 10.8790252 13.3321388 0 13.3321388"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFF152",
    points: "0 0 6.21677631 0 6.21677631 1.52386346 0 1.52386346"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FF5B5B",
    points: "9.32516447 3.04706032 9.32516447 1.52386346 7.77063708 1.52386346 7.77063708 0 6.21677631 0 6.21677631 4.57092378 10.8790252 4.57092378 10.8790252 3.04706032"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#551C99",
    points: "9.32516447 6.09478724 9.32516447 4.57092378 10.8790252 4.57092378"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#999131",
    points: "6.21677631 0 6.21677631 1.52386346 4.66224893 1.52386346"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGiphy);
export default __webpack_public_path__ + "static/media/icGiphy.55221fc763b27650aa695d1e874b44d6.svg";
export { ForwardRef as ReactComponent };